import { useEffect, useState } from "react";

const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 768); // 모바일 기준 너비
    };

    checkDevice(); // 첫 실행

    window.addEventListener("resize", checkDevice); // 창 크기 변경 대응

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return isMobile;
};

export default useDeviceType;
